import { render, staticRenderFns } from "./DomainSecurity.vue?vue&type=template&id=f1d97b22&scoped=true&"
import script from "./DomainSecurity.vue?vue&type=script&lang=ts&"
export * from "./DomainSecurity.vue?vue&type=script&lang=ts&"
import style0 from "./DomainSecurity.vue?vue&type=style&index=0&id=f1d97b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d97b22",
  null
  
)

export default component.exports